var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lancamentos-lista-base',{attrs:{"tipo":"receber","titulo":"Financeiro - Contas a Receber"}})
}
var staticRenderFns = []

export { render, staticRenderFns }